import Cookies from './cookies';

export default {

  /**
   * Get the configuration to pass to an axios call (really just adding the auth token)
   *
   * @param {string} cookieNameSpace
   * @returns {object}
   */
  getConfig(cookieNameSpace) {
    let authToken;
    if (cookieNameSpace) {
      authToken = Cookies.getCookie(`${cookieNameSpace}-auth-token`);
    } else {
      authToken = Cookies.getCookie('auth-token');
    }
    return {
      headers: { 'X-API-AUTHTOKEN': `${authToken}` },
    };
  },
};
